// extracted by mini-css-extract-plugin
module.exports = {"root":"_1s7KL","content-wrapper":"DRgwo","contentWrapper":"DRgwo"};